import React, { Fragment } from 'react'
import { Outlet } from 'react-router-dom';

function PolicysLayout() {

    return (
        <Fragment>
            <div className="jewllery-policys">
                <Outlet />
            </div>
        </Fragment>

    );
}

export default PolicysLayout;